/**
 * Site sensors fetch thunk — loads the FE-contract sensor readings snapshot
 * for a single site and seeds the siteSensors slice.
 *
 * Dispatched lazily by the site dashboard bootstrap thunk when
 * display.cards.sensor.visible is true.
 */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { extractThunkError } from '@sophocles/api/thunkUtils';
import { fetchSiteSensorsApi } from '@sophocles/features/siteSensors/api';

/**
 * Fetch the sensor readings contract for a site and seed the siteSensors slice.
 *
 * @param {number|string} siteId
 */
export const fetchSiteSensors = createAsyncThunk('siteSensors/fetch', async (siteId, { rejectWithValue }) => {
  try {
    const data = await fetchSiteSensorsApi(siteId);
    return data;
  } catch (e) {
    return rejectWithValue(extractThunkError(e));
  }
});
